import register from '@kpsys/angularjs-register';
import {VisitedDocumentsDataService} from './visited-documents.data-service';
import ngAsyncDecoratorHelperModule from 'shared/utils/ng-@decorators';
import {KpVisitedPanelPresenter} from './kp-visited-panel.presenter';

export default register('portaro.features.record.visited-panel', [ngAsyncDecoratorHelperModule])
    .service(VisitedDocumentsDataService.serviceName, VisitedDocumentsDataService)
    .service(KpVisitedPanelPresenter.presenterName, KpVisitedPanelPresenter)
    .name();
